import { RootState } from '..'

export const hasCompletedOnboardingSelector = (state: RootState) =>
  state.user.onboarding_profile_completed && state.user.onboarding_fitness_survey_completed
